/**
 * "STILLER WARENKORB" — adding no longer hijacks the page.
 *
 * Dawn's CartDrawer.renderContents() re-renders the drawer's sections and
 * then calls this.open() from inside a setTimeout, so every single add --
 * from a product page, a quick-add tile, the box builder, the cart upsell --
 * slid the whole drawer over the page and interrupted whatever the customer
 * was doing. For a store whose entire premise is "fill a box with several
 * things", that interruption fires exactly when you least want it.
 *
 * The drawer itself is untouched and still opens normally when the customer
 * asks for it (clicking the header box, or Shopify's own openCart action).
 * Only the automatic open that renderContents performs is suppressed, and
 * only for the duration of that call.
 *
 * Discriminating on open()'s `triggeredBy` argument would have been
 * shorter, but standard-actions-override.js legitimately calls open() with
 * no argument too -- an explicit flag is the only way to tell "the customer
 * asked" apart from "a re-render did it on its own".
 */
(function () {
  function quiet(tagName) {
    var ctor = customElements.get(tagName);
    if (!ctor || ctor.prototype.__candyQuiet) return false;

    var proto = ctor.prototype;
    var originalRender = proto.renderContents;
    var originalOpen = proto.open;
    if (typeof originalRender !== 'function' || typeof originalOpen !== 'function') return false;

    proto.renderContents = function (parsedState) {
      this.__candySuppressOpen = true;
      originalRender.call(this, parsedState);
      // renderContents defers its open() into a zero-delay setTimeout, so
      // this one -- queued afterwards at the same delay -- runs strictly
      // after it and releases the flag only once that open attempt is past.
      var self = this;
      setTimeout(function () { self.__candySuppressOpen = false; }, 0);
    };

    proto.open = function (triggeredBy) {
      if (this.__candySuppressOpen) return;
      return originalOpen.call(this, triggeredBy);
    };

    proto.__candyQuiet = true;
    return true;
  }

  function apply() {
    // cart-notification is patched too so the behaviour holds if the cart
    // type is ever switched away from "drawer" in theme settings.
    var done = 0;
    ['cart-drawer', 'cart-notification'].forEach(function (tag) {
      if (quiet(tag)) done++;
    });
    return done;
  }

  if (!apply()) {
    // The custom elements define themselves from deferred scripts, so if
    // neither was registered yet, wait for whichever arrives.
    ['cart-drawer', 'cart-notification'].forEach(function (tag) {
      if (customElements.get(tag)) return;
      customElements.whenDefined(tag).then(function () { quiet(tag); });
    });
  }
})();
